// extracted by mini-css-extract-plugin
module.exports = {"_positionContainer":"LieferungPositionenList__positionContainer__39fpo"};